export function getAutoCompleteFieldParams(key: string, parameters: any, keyToSet?: string): Map<string, string> {
    const params = new Map();

    if (parameters[key]) {
        if (keyToSet) {
            params.set(keyToSet, parameters[key]);
        } else {
            params.set(key, parameters[key]);
        }
    }

    return params;
}
